import { render, staticRenderFns } from "./EditSeasonalIngredientsList.vue?vue&type=template&id=4391594a&scoped=true"
import script from "./EditSeasonalIngredientsList.vue?vue&type=script&lang=js"
export * from "./EditSeasonalIngredientsList.vue?vue&type=script&lang=js"
import style0 from "./EditSeasonalIngredientsList.vue?vue&type=style&index=0&id=4391594a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4391594a",
  null
  
)

export default component.exports